<template>
  <!-- 市区板块内容部分第二块-->
  <div class="box">
    <div class="contentBox">
      <button class="TopListbtn" @mouseenter="LandRoamBtnenter()">
        <a-icon type="snippets" /><span>土地流转</span>
      </button>
      <button class="TopListbtn" @mouseenter="LandTrustBtnenter()">
        <a-icon type="container" /><span>土地托管</span>
      </button>

      <button class="TopListbtn" @mouseenter="TalentBtnenter()">
        <a-icon type="video-camera" /><span>农村人才</span>
      </button>

      <button class="TopListbtn" @mouseenter="MachineryServerBtnenter()">
        <a-icon type="audit" /><span>农机服务</span>
      </button>
      <button class="TopListbtn" @mouseenter="FinancialBtnenter()"><a-icon type="audit" /><span>金融保险</span></button>
    </div>
    <div v-if="box & (btnType === '土地流转')">
      <city-lists-box>
        <template v-slot:cityListBoxOne>
          <a-table :columns="columns" :data-source="listData.slice(0, 5)" :pagination="pagination" >
          </a-table>
        </template>
      </city-lists-box>
    </div>
    <div v-else-if="(btnType === '农村人才')|(btnType === '农村劳务')|(btnType === '专业人才')">
      <!-- 经营主体下的子版块 -->
      <div v-if="btn">
        <button class="smallBtn" @mouseenter="RuralLaborEnter">
          <span>农村劳务</span>
        </button>
        <button class="smallBtn" @mouseenter="TalentsEnter">
          <span>专业人才</span>
        </button>
      </div>
      <div v-if="(this.btnType === '专业人才')|(this.btnType === '农村人才')" style="background:#fff;">
        <a-table :columns="Talentscolums" :data-source="TalentsInfoData.slice(0, 5)" :pagination="pagination"> 
          <span slot="Talentsexpertise" slot-scope="text">{{ text | expertiseFilter }}</span>
        </a-table>
      </div>
      <div v-if="this.btnType === '农村劳务'" style="background:#fff; width:100%;height:300px">
        <a-table :columns="FarmerInfocolums" :data-source="FarmerInfoData" :pagination="pagination"> </a-table>
      </div>
    </div>
    <div v-else-if="box & btnType === '农机服务'">
      <div style="width:100%;height:300px">
        <a-table :columns="Machinerycolumns" :data-source="FarmMachineData" :pagination="pagination"> </a-table>
      </div>
    </div>
    <div v-else-if="box & (btnType === '金融保险')">
      <city-lists-box></city-lists-box>
    </div>
    <div v-if="citysearchBox & (btnType === '土地托管')">
      <citysearch-Box title="土地全托" tType="0" style="float:left;background:#ccc;width:49%"></citysearch-Box>
      <citysearch-Box title="土地半托" tType="1" style="float:right;background:#ccc;width:49%"></citysearch-Box>
      <div style="clear: both"></div>
    </div>
    <div v-else-if="citysearchBox & (btnType === '金融保险')">
      <citysearch-Box title="农业贷款" infoType="10" style="float:left;background:#ccc;width:49%"></citysearch-Box>
      <citysearch-Box title="农业保险" infoType="11" style="float:right;background:#ccc;width:49%"></citysearch-Box>
      <div style="clear: both"></div>
    </div>
  </div>
</template>
<script>
import citysearchBox from '@/layouts/topBox/cityBox/citysearchBox.vue'
import cityListsBox from '@/layouts/topBox/cityBox/cityListsBox.vue'
import { LandTransferAreaWebPage } from '@/api/main/LandTransferAreaManager'
import { FarmMachineInformationWebPage } from '@/api/main/FarmMachineInformationManage'
import { TalentsInfoWebPage } from '@/api/main/TalentsInfoManager'
import { FarmerInfoWebPage } from '@/api/main/FarmerInfoManager'
export default {
  components: {
    citysearchBox,
    cityListsBox
  },
  data() {
    return {
      oDiv: '',
      colorData: '#e6dfcf',
      btn: false,
      box: true,
      citysearchBox: false,
      FarmMachineData: [],
      TalentsInfoData: [],
      FarmerInfoData: [],
      /**
       * 1.土地流转 2.土地托管 3.农村人才 4.农机服务 5.金融保险
       */
      btnType: '',
      pagination: false,
      columns: [
        {
          title: '片区名',
          dataIndex: 'areaName'
        },
        {
          title: '片区面积',
          dataIndex: 'areaSize',
          width: 140
        },
        {
          title: '租赁价格',
          dataIndex: 'price',
          width: 140
        },
        {
          title: '发布日期',
          dataIndex: 'publishDate',
          width: 300
        }
      ],
      Machinerycolumns: [
        {
          title: '农机所有人',
          dataIndex: 'fName',
          width: 140
        },
        {
          title: '农机具类型',
          dataIndex: 'mType',
          width: 140
        },
        {
          title: '农机具型号',
          dataIndex: 'modelNumber',
          width: 140
        },
        {
          title: '作业单价',
          dataIndex: 'price',
          width: 140
        },
        {
          title: '发布日期',
          dataIndex: 'publishDate',
          width: 300
        }
      ],
      Talentscolums: [
        {
          title: '姓名',
          dataIndex: 'name'
        },
        {
          title: '性别',
          dataIndex: 'gender',
          width: 140
        },
        {
          title: '专业专长',
          dataIndex: 'expertise',
          width: 140
        },
        {
          title: '从业年限',
          dataIndex: 'numberOfYears',
          width: 140
        },
        {
          title: '意向服务地区',
          dataIndex: 'publishDate'
        },
        {
          title: '发布日期',
          dataIndex: 'publishDate',
          width: 140
        }
      ],
      FarmerInfocolums: [
        {
          title: '所在村级',
          dataIndex: 'sysOrgName'
        },
        {
          title: '姓名',
          dataIndex: 'name',
          width: 140
        },
        {
          title: '性别',
          dataIndex: 'gender',
          width: 140
        },
        {
          title: '从业状态',
          dataIndex: 'employmentStatus',
          width: 140
        },
        {
          title: '技能专长',
          dataIndex: 'expertise'
        },
        {
          title: '发布日期',
          dataIndex: 'publishTime',
          width: 140
        },
        {
          title: '发布日期',
          dataIndex: 'publishDate',
          width: 140
        }
      ]
    }
  },
  methods: {
    enter() {
      /** 按钮 */
      this.btn = false
      /** 盒子 */
      this.box = true
      /** 查询盒子 */
      this.citysearchBox = false
      if (this.btnType === '农村人才') {
        this.btn = true
          TalentsInfoWebPage().then(res => {
          this.TalentsInfoData = ''
          this.TalentsInfoData = res.data.rows
          })
      } else if (this.btnType === '专业人才') {
        this.btn = true
          TalentsInfoWebPage().then(res => {
          this.TalentsInfoData = res.data.rows
          })
      } else if (this.btnType === '农村劳务') {
        this.btn = true
          FarmerInfoWebPage().then(res => {
          this.FarmerInfoData = res.data.rows
          })
      } else if (this.btnType === '土地托管' || this.btnType === '金融保险') {
        this.box = false
        this.citysearchBox = true
      } else if (this.btnType === '土地流转') {
        LandTransferAreaWebPage({ orgId: this.orgId }).then(res => {
        this.listData = ''
        this.listData = res.data.rows
      })
      } else if (this.btnType === '农机服务') {
       FarmMachineInformationWebPage().then(res => {
        this.FarmMachineData = ''
        this.FarmMachineData = res.data.rows
      })
      }
    },
    LandRoamBtnenter() {
      this.infoType = 101
      this.btnType = '土地流转'
      this.enter()
    },
    LandTrustBtnenter() {
      this.btnType = '土地托管'
      this.enter()
    },
    TalentBtnenter() {
      this.btnType = '农村人才'
      this.enter()
    },
    TalentsEnter() {
      this.btnType = '专业人才'
      this.enter()
    },
    RuralLaborEnter() {
      this.btnType = '农村劳务'
      this.enter()
    },
    MachineryServerBtnenter() {
      this.btnType = '农机服务'
      this.enter()
    },
    FinancialBtnenter() {
      this.btnType = '金融保险'
      this.enter()
    }
  },
  filters: {
      expertiseFilter: (val) => {
        if (val === '0') {
          return '生产型人才'
        }else if (val === '1') {
          return '经营型人才'
        }else if (val === '2') {
          return '社会服务型人才'
        }else{
          return '其他'
        }
      }
  }
}
</script>
<style scoped>
    .box{
      width: 100%;
      height: 400px;
    }
    .contentBox :first-child {
      margin-left: 0px;
    }

    .contentBox :last-child {
      margin-right: 0px;
    }

    .TopListbtn {
      width: 19.65%;
      height: 75px;
      margin-left: 5px;
      font-weight: 800;
      font-size: 16px;
      background: #e6dfcf;
    }

    .TopListbtn:hover {
      background-color: #207e63;
      color: #fff;
    }
    .smallBtn {
      width: 115px;
      height: 40px;
    }
</style>
